import { create } from "zustand";

type TFilterBarStore = {
  visible: Record<string, boolean>;
  setVisible: (viewName: string, value: boolean) => void;
  resetAll: () => void;
};

export const useFilterBarStore = create<TFilterBarStore>((set) => ({
  visible: {},

  setVisible: (viewName, value) =>
    set((state) => ({
      visible: {
        ...state.visible,
        [viewName]: value,
      },
    })),

  resetAll: () => set({ visible: {} }),
}));
